import accRepaymentRemindController from '~/config/server/datasync-service/acc-repayment-remind.controller';
import userActiveMqController from '~/config/server/datasync-service/user-activemq.controller';
import departmentInfoController from '~/config/server/datasync-service/department-info.controller';
export var datasyncService = {
    accRepaymentRemindController: accRepaymentRemindController,
    userActiveMqController: userActiveMqController,
    departmentInfoController: departmentInfoController
};
